export default __webpack_public_path__ + "static/media/Placeholder.742a1c68.png";